import { createContext } from 'react';
import { CustomerDataInterpreter } from '../machines/customerData/types';
import { CustomFieldsInterpreter } from '../machines/customFields/types';

export const GlobalStateContext = createContext<{
  customerDataService: CustomerDataInterpreter;
  customFieldsService: CustomFieldsInterpreter;
}>({
  customerDataService: null,
  customFieldsService: null,
});
